import { Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import _ from "lodash";
import { getPresignedUrl } from "../../upload/utils";
import { getFooter } from "../../../utils/helperUtils";

const styles = StyleSheet.create({
    page: {
        padding: "30px 40px",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    heading: {
        fontSize: 12,
        fontWeight: "bold",
        marginBottom: 10,
        textAlign: "center",
        color: "#2c3e50",
        textTransform: "uppercase",
        borderBottom: "1px solid #3498db",
        paddingBottom: 5,
    },
    section: {
        display: "flex",
        flexDirection: "column",
        gap: 15,
        marginBottom: 10,
        height: "90%",
    },
    imageContainer: {
        flex: 1,
        marginBottom: 15,
        border: "1px solid #e0e0e0",
        borderRadius: 4,
        overflow: "hidden",
        backgroundColor: "#f8f9fa",
        maxHeight: "42%",
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    mainContainer: {
        height: "90%",
        paddingBottom: 30,
    },
});

const groupAndPairImages = data => {
    const mapsAndImages = _.get(
        data,
        "appealApproachCalculationData.exportAppealsPackage.mapsAndImages",
        []
    );

    const enabledImages = mapsAndImages.filter(image => image.enable === true);

    const imagesByType = enabledImages.reduce((acc, image) => {
        if (!acc[image.type]) {
            acc[image.type] = [];
        }
        acc[image.type].push(image.canopyS3Key);

        return acc;
    }, {});

    return Object.entries(imagesByType).map(([type, images]) => ({
        type,
        pairs: _.chunk(images, 2),
    }));
};

const ImageWithContainer = ({ imageS3Key }) => (
    <View style={styles.imageContainer}>
        <Image source={getPresignedUrl(imageS3Key)} style={styles.image} />
    </View>
);

const ImagePage = ({ type, images, confidentialInfo }) => (
    <Page size="A4" style={styles.page}>
        <View style={styles.mainContainer}>
            <View style={styles.section}>
                <Text style={styles.heading}>{type}</Text>
                {images.map((imageS3Key, index) => (
                    <ImageWithContainer key={`${imageS3Key}-${index}`} imageS3Key={imageS3Key} />
                ))}
            </View>
        </View>

        {getFooter(confidentialInfo)}
    </Page>
);

export const PropertyImagesPage = ({ data, confidentialInfo }) => {
    const groupedImages = groupAndPairImages(data);

    return (
        <>
            {groupedImages.map(imageGroup =>
                imageGroup.pairs.map((pair, pairIndex) => (
                    <ImagePage
                        key={`${imageGroup.type}-${pairIndex}`}
                        type={imageGroup.type}
                        images={pair}
                        confidentialInfo={confidentialInfo}
                    />
                ))
            )}
        </>
    );
};
